import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BrTabItems } from 'views/BrTabs/BrTabs';

export const initialBrTabsState = {
  tab: 'core-data',
};

export type BrTabsState = {
  tab: BrTabItems;
};

const brTabsSlice = createSlice({
  name: 'BR_TABS',
  initialState: initialBrTabsState,
  reducers: {
    setBrTab: (state, action: PayloadAction<BrTabItems>) => {
      return { ...state, tab: action.payload };
    },
  },
});

export const { setBrTab } = brTabsSlice.actions;

export default brTabsSlice.reducer;
